module.exports = __webpack_public_path__ + "static/media/BudgetSmartSlide04.0c526275.jpg";